
import {defineComponent} from "vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import PopupMetaData from "@/components/layouts/content-pages/popups/PopupMetaData.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default defineComponent({
  name: "PopupDetail",
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    },
    id(): string {
      return this.$route.params.id as string;
    }
  },
  components: {
    PopupMetaData,
    BaseTitle,
  }
});
